import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from 'react-cookie';
import {
    Button,
    Grid
} from '@material-ui/core';

const styles = () => ({
    displayFlex: {
        display: 'flex'
    },
    verticalSpace: {
        margin: '5px 50px 0px 0px',
    },
    searchButtonSpace: {
        margin: '5px 0px 0px 0px',
    },
    sendButton:{
        margin: '5px 0px 0px 0px',
        color: "white",
        width: "120px",
        backgroundColor: "#4EDE80",
        '&:hover': {
            backgroundColor: "#8AD68A",
        }
    }
});

const SendButton = withCookies((props) => {
    const {
        classes,
        chatId
    } = props;

    const sendButtonClick = () => {
        const url = `/message?cid=${chatId}`
        window.open(url, '_blank', 'noopener,noreferrer');
    };


    return (
        <React.Fragment>
            <Grid>
                <div>
                    <div className={classes.displayFlex + ' ' + classes.verticalSpace}>
                        <Button size="large" className={classes.sendButton} variant="contained" onClick={() => sendButtonClick()}>{'個別送信'}</Button>
                    </div>
                </div>
            </Grid>
        </React.Fragment>
    );
});

SendButton.propTypes = {
    classes: PropTypes.object.isRequired,
    chatId: PropTypes.string.isRequired,
};

export default withStyles(styles)(SendButton);